import { FC, PropsWithChildren, ReactElement } from 'react';
import { Button, Modal } from '@digital-pulse/react';
import styles from './memberIDModal.module.scss';
import Info2 from '../../public/images/info2.svg';
import PrescriptionCard from '../../public/images/prescriptionCard.svg';
import InsuranceCard from '../../public/images/insuranceCard.svg';

import { ALT_TEXT } from '@/lib/constants';

interface Props {
  memberIDModalOpen: boolean;
  setMemberIDModalOpen: any;
  translations?: any;
}

const MemberIDModal: FC<PropsWithChildren<Props>> = ({
  memberIDModalOpen,
  setMemberIDModalOpen,
  translations
}: Props): ReactElement => {
  const modalContent = translations?.MEMBER_ID_MODAL;

  return (
    <>
      <Button
        variant="text"
        size="md"
        className={styles.memberID__link}
        onClick={() => setMemberIDModalOpen(true)}
        renderIcon={<Info2 aria-hidden={true} />}
      >
        {modalContent?.TITLE}
      </Button>
      <Modal
        heading={modalContent?.TITLE}
        isOpen={memberIDModalOpen}
        onClose={() => setMemberIDModalOpen(false)}
        className={styles.memberID__modal}
      >
        <div className={styles.memberID__imageContainer}>
          <PrescriptionCard role="img" aria-label={ALT_TEXT.prescriptionCard} />
          <InsuranceCard role="img" aria-label={ALT_TEXT.insuranceCard} />
        </div>
        <p className={styles.modal__list}>
          {modalContent?.TRY}
          <ul>
            <li>{modalContent?.LOCATING}</li>
            <li>{modalContent?.REMOVING}</li>
            <li>{modalContent?.ENTERING}</li>
          </ul>
        </p>
      </Modal>
    </>
  );
};

export default MemberIDModal;
